// tiptap用のiframeを作成する関数
// ref:https://tiptap.dev/docs/editor/experiments/embeds

import { Node } from "@tiptap/core";

export interface IframeOptions {
  width: string;
  height: string;
  HTMLAttributes: {
    [key: string]: any;
  };
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    iframe: {
      /**
       * Add an iframe
       */
      setIframe: (options: { src: string }) => ReturnType;
    };
  }
}

export default Node.create<IframeOptions>({
  name: "iframe",

  group: "block",
  // content: 'block*',

  draggable: true,

  "data-drag-handle": true,

  atom: true,

  addOptions() {
    return {
      width: "560",
      height: "315",
      HTMLAttributes: {
        class: "iframe-wrapper",
      },
    };
  },

  addAttributes() {
    return {
      src: {
        default: null,
      },
      width: {
        default: this.options.width,
      },
      height: {
        default: this.options.height,
      },
      frameborder: {
        default: 0,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "iframe",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["iframe", HTMLAttributes];
  },

  renderText() {
    return "renderText";
  },

  addCommands() {
    return {
      setIframe:
        (options: { src: string }) =>
        ({ tr, dispatch }) => {
          const { selection } = tr;
          const node = this.type.create(options);

          if (dispatch) {
            tr.replaceRangeWith(selection.from, selection.to, node);
          }

          return true;
        },
    };
  },

  addNodeView() {
    return ({ node, editor }) => {
      const {
        options: { editable },
      } = editor;
      const { src, width, height } = node.attrs;
      const $iframe = document.createElement("iframe");

      $iframe.setAttribute("src", src);
      $iframe.setAttribute("width", width);
      $iframe.setAttribute("height", height);

      if (!editable) return { dom: $iframe };

      const $container = document.createElement("div");
      $container.appendChild($iframe);

      // 編集モードの際にはドラッグできるようにiframe内のクリックイベントを無効化
      $iframe.setAttribute("style", "pointer-events: none;");

      return {
        dom: $container,
      };
    };
  },
});
